/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountStatus.defs'
export { main as default } from './getAccountStatus.defs'
